/// \file checkingPassword.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

const CheckingPasswords = {
    checkValidPasswordShower: function(
        passwordValue:string,
        lengthElement:HTMLDivElement,
        lengthShapeElement:HTMLSpanElement,
        numericElement:HTMLDivElement,
        numericShapeElement:HTMLSpanElement,
        lowerElement:HTMLDivElement,
        lowerShapeElement:HTMLSpanElement,
        upperElement:HTMLDivElement,
        upperShapeElement:HTMLSpanElement,
        specialElement:HTMLDivElement,
        specialShapeElement:HTMLSpanElement,
        firstElement:HTMLDivElement,
        firstShapeElement:HTMLSpanElement
        )
    {
        if(passwordValue.length<8){
            lengthElement.classList.add("notValid")
            lengthElement.classList.remove("valid")
            lengthShapeElement.classList.add("redFaultCircle")
            lengthShapeElement.classList.remove("greenCheckCircle")
            lengthShapeElement.innerText = "\u2717"
          }
          else{
            lengthElement.classList.add("valid")
            lengthElement.classList.remove("notValid")
            lengthShapeElement.classList.add("greenCheckCircle")
            lengthShapeElement.classList.remove("redFaultCircle")
            lengthShapeElement.innerText = "\u2713"
          }
          let numberOfUnique = 0;
          let numberUsed = 0;
          let specialCharacterUsed = 0;
          let upperCaseCharacterUsed = 0;
          let lowerCaseCharacterUsed = 0;
          let firstCharBeString = 0;
          for(let i = 0;i<passwordValue.length;i++){
              const characterInPassword = passwordValue[i];//1 character of the password
              if(characterInPassword==" "){ //otherwise might be considered a number
              }
              else if(!Number.isNaN(Number(characterInPassword))){ //number
                  numberUsed = 1;
              }
              else{
                  if(characterInPassword.toLowerCase()!=characterInPassword.toUpperCase()){ //letter
                      if(i==0){
                          firstCharBeString = 1;
                      }
                      if(characterInPassword==characterInPassword.toLowerCase()){
                          lowerCaseCharacterUsed = 1;
                      }
                      else if(characterInPassword==characterInPassword.toUpperCase()){
                          upperCaseCharacterUsed = 1;
                      }
                      else{
                          console.log("unmarked unknown character: |"+characterInPassword+"|");
                      }
                  }
                  else if(characterInPassword=="#" || characterInPassword=="$" || characterInPassword=="@" || characterInPassword=="_"
                  || characterInPassword=="*" || characterInPassword=="!" || characterInPassword=="%"){ //special
                  specialCharacterUsed = 1;
                  }
              }
          }
          if(numberUsed){
            numberOfUnique+=1;
            numericElement.classList.add("valid")
            numericElement.classList.remove("notValid")
            numericShapeElement.classList.add("greenCheckCircle")
            numericShapeElement.classList.remove("redFaultCircle")
            numericShapeElement.innerText = "\u2713"
          }
          else{
            numericElement.classList.remove("valid")
            numericElement.classList.add("notValid")
            numericShapeElement.classList.add("redFaultCircle")
            numericShapeElement.classList.remove("greenCheckCircle")
            numericShapeElement.innerText = "\u2717"
          }
          if(lowerCaseCharacterUsed){
            numberOfUnique+=1;
            lowerElement.classList.add("valid")
            lowerElement.classList.remove("notValid")
            lowerShapeElement.classList.add("greenCheckCircle")
            lowerShapeElement.classList.remove("redFaultCircle")
            lowerShapeElement.innerText = "\u2713"
          }
          else{
            lowerElement.classList.remove("valid")
            lowerElement.classList.add("notValid")
            lowerShapeElement.classList.add("redFaultCircle")
            lowerShapeElement.classList.remove("greenCheckCircle")
            lowerShapeElement.innerText = "\u2717"
          }
          if(upperCaseCharacterUsed){
            numberOfUnique+=1;
            upperElement.classList.add("valid")
            upperElement.classList.remove("notValid")
            upperShapeElement.classList.add("greenCheckCircle")
            upperShapeElement.classList.remove("redFaultCircle")
            upperShapeElement.innerText = "\u2713"
          }
          else{
            upperElement.classList.remove("valid")
            upperElement.classList.add("notValid")
            upperShapeElement.classList.add("redFaultCircle")
            upperShapeElement.classList.remove("greenCheckCircle")
            upperShapeElement.innerText = "\u2717"
          }
          if(specialCharacterUsed){
            numberOfUnique+=1;
            specialElement.classList.add("valid")
            specialElement.classList.remove("notValid")
            specialShapeElement.classList.add("greenCheckCircle")
            specialShapeElement.classList.remove("redFaultCircle")
            specialShapeElement.innerText = "\u2713"
          }
          else{
            specialElement.classList.remove("valid")
            specialElement.classList.add("notValid")
            specialShapeElement.classList.add("redFaultCircle")
            specialShapeElement.classList.remove("greenCheckCircle")
            specialShapeElement.innerText = "\u2717"
          }
          if(firstCharBeString){
            firstElement.classList.add("valid")
            firstElement.classList.remove("notValid")
            firstShapeElement.classList.add("greenCheckCircle")
            firstShapeElement.classList.remove("redFaultCircle")
            firstShapeElement.innerText = "\u2713"
          }
          else{
            firstElement.classList.remove("valid")
            firstElement.classList.add("notValid")
            firstShapeElement.classList.add("redFaultCircle")
            firstShapeElement.classList.remove("greenCheckCircle")
            firstShapeElement.innerText = "\u2717"
          }
    },

    checkValidPassword: function(passwordValue:string,passwordSettings?:any){
    let erasePassword = false;
    let numberOfUnique = 0;
    let numberUsed = 0;
    let specialCharacterUsed = 0;
    let upperCaseCharacterUsed = 0;
    let lowerCaseCharacterUsed = 0;
    let firstCharBeString = 0;
    console.log("testing password: ", passwordValue)
    if(passwordValue.length<8){//less than 8 is bad
    erasePassword = true;
    }
    for(let i = 0;i<passwordValue.length;i++){
        const characterInPassword = passwordValue[i];//1 character of the password
        if(characterInPassword==" "){ //otherwise might be considered a number
        }
        else if(!Number.isNaN(Number(characterInPassword))){ //number
            numberUsed = 1;
        }
        else{
            if(characterInPassword.toLowerCase()!=characterInPassword.toUpperCase()){ //letter
                if(i==0){
                    firstCharBeString = 1;
                }
                if(characterInPassword==characterInPassword.toLowerCase()){
                    lowerCaseCharacterUsed = 1;
                }
                else if(characterInPassword==characterInPassword.toUpperCase()){
                    upperCaseCharacterUsed = 1;
                }
                else{
                    console.log("unmarked unknown character: |"+characterInPassword+"|");
                }
            }
            else if(characterInPassword=="#" || characterInPassword=="$" || characterInPassword=="@" || characterInPassword=="_"
                  || characterInPassword=="*" || characterInPassword=="!" || characterInPassword=="%"){ //special
            specialCharacterUsed = 1;
            }
        }
    }
    numberOfUnique = numberUsed + specialCharacterUsed + upperCaseCharacterUsed + lowerCaseCharacterUsed
    console.log(numberUsed, specialCharacterUsed, upperCaseCharacterUsed, lowerCaseCharacterUsed, numberOfUnique);
    if(numberOfUnique<4){
        erasePassword=true
    }
    if(firstCharBeString==0){
        erasePassword = true;
    }
    if(erasePassword){
        console.log("invalid password")
        return(false)
    }
    else{
        console.log("valid password")
        return(true)
    }
  }
}
export default CheckingPasswords;
